import { Injectable } from '@angular/core'
import { FirebaseAnalytics } from '@capacitor-community/firebase-analytics'
import { environment } from '@env/environment'
import mixpanel from 'mixpanel-browser'
import * as R from 'ramda'
import { AuthService } from './auth.service'

@Injectable({
  providedIn: 'root',
})
export class AnalyticService {
  constructor(private auth: AuthService) {
    // GA4
    FirebaseAnalytics.setCollectionEnabled({
      enabled: true,
    }).catch(e => {})
    FirebaseAnalytics.setUserProperty({
      name: 'debug_mode',
      value: `true`,
    }).catch(e => {})

    // Mixpanel
    mixpanel.init(environment.mixpanel, { debug: environment.env !== 'prod' })

    //
    this.setUser()
  }

  page(screenName, nameOverride) {
    FirebaseAnalytics.setScreenName({
      screenName,
      nameOverride,
    })
  }

  /**
   * 이벤트 보내기
   *
   * @param names
   * @param params
   */

  events(names: string[], params: any) {
    R.forEach((name: string) => {
      // GA4
      FirebaseAnalytics.logEvent({
        name,
        params,
      }).catch(e => {})

      // Mixpanel
      mixpanel.track(name, params)
    }, names)
  }

  /**
   * 사용자 정보 보내기
   */
  private setUser() {
    let previousUserId = this.auth.userId

    if (previousUserId) mixpanel.identify(`${this.auth.userId}`)

    this.auth.isAuthenticated.subscribe(authenticated => {
      if (!previousUserId && authenticated) {
        // mixpanel
        mixpanel.identify(`${this.auth.userId}`)

        // GA4
        FirebaseAnalytics.setUserId({
          userId: `${this.auth.userId}`,
        }).catch(e => {})
        FirebaseAnalytics.setUserProperty({
          name: 'member_id',
          value: `${this.auth.userId}`,
        }).catch(e => {})
        return
      }

      if (previousUserId && !authenticated) {
        // mixpanel
        mixpanel.reset()
        // GA4
        FirebaseAnalytics.reset()
        // var
        previousUserId = undefined
      }
    })
  }
}
